import { useEffect, useState } from "react";

const calc = (end) => {
  const ms = Math.max(0, new Date(end).getTime() - Date.now());
  return [86400000, 3600000, 60000, 1000].map((u, i, a) => Math.floor((i ? ms % a[i - 1] : ms) / u));
};

export const Countdown = ({ end }) => {
  const [parts, setParts] = useState(() => calc(end));
  useEffect(() => {
    setParts(calc(end));
    const t = setInterval(() => setParts(calc(end)), 1000);
    return () => clearInterval(t);
  }, [end]);

  return (
    <div className="flex gap-2 sm:gap-3" data-testid="leaderboard-countdown">
      {["Days", "Hrs", "Min", "Sec"].map((l, i) => (
        <div key={l} className="count-cell">
          <span className="font-mono text-2xl font-bold text-white sm:text-3xl">{String(parts[i]).padStart(2, "0")}</span>
          <span className="text-[11px] uppercase tracking-[0.2em] text-white/75">{l}</span>
        </div>
      ))}
    </div>
  );
};
